export const SUPPORTED_LOCALES = [
    'en',
    'ru',
    'lv',
    'de',
    'fr',
    'es',
    'it',
    'pt',
    'pl',
    'uk',
    'ro',
    'nl',
    'cs',
    'sk',
    'hu',
    'bg',
    'el',
    'sv',
    'nb',
    'da',
    'fi',
    'lt',
    'et',
    'hr',
    'sr',
    'sl',
    'tr',
    'zh-CN',
    'zh-TW',
    'ja',
    'ko',
    'hi',
    'id',
    'vi',
    'th',
    'ms',
    'fil',
    'ar',
    'he',
    'fa',
    'pt-BR',
    'es-419',
];
const SUPPORTED_SET = new Set(SUPPORTED_LOCALES);
/** BCP-47 and legacy locale tags mapped to a supported locale. */
export const LOCALE_ALIASES = {
    en: 'en',
    'en-us': 'en',
    'en-gb': 'en',
    'en-au': 'en',
    'en-ca': 'en',
    'en-nz': 'en',
    'en-ie': 'en',
    'en-za': 'en',
    'en-in': 'en',
    ru: 'ru',
    'ru-ru': 'ru',
    lv: 'lv',
    'lv-lv': 'lv',
    de: 'de',
    'de-de': 'de',
    'de-at': 'de',
    'de-ch': 'de',
    'de-li': 'de',
    'de-lu': 'de',
    fr: 'fr',
    'fr-fr': 'fr',
    'fr-be': 'fr',
    'fr-ca': 'fr',
    'fr-ch': 'fr',
    'fr-lu': 'fr',
    es: 'es',
    'es-es': 'es',
    'es-419': 'es-419',
    'es-mx': 'es-419',
    'es-ar': 'es-419',
    'es-co': 'es-419',
    'es-cl': 'es-419',
    'es-pe': 'es-419',
    'es-ve': 'es-419',
    'es-ec': 'es-419',
    'es-gt': 'es-419',
    'es-cr': 'es-419',
    'es-pa': 'es-419',
    'es-do': 'es-419',
    'es-uy': 'es-419',
    'es-py': 'es-419',
    'es-bo': 'es-419',
    'es-hn': 'es-419',
    'es-ni': 'es-419',
    'es-sv': 'es-419',
    'es-pr': 'es-419',
    it: 'it',
    'it-it': 'it',
    'it-ch': 'it',
    pt: 'pt',
    'pt-pt': 'pt',
    'pt-br': 'pt-BR',
    pl: 'pl',
    'pl-pl': 'pl',
    uk: 'uk',
    'uk-ua': 'uk',
    ro: 'ro',
    'ro-ro': 'ro',
    'ro-md': 'ro',
    nl: 'nl',
    'nl-nl': 'nl',
    'nl-be': 'nl',
    cs: 'cs',
    'cs-cz': 'cs',
    sk: 'sk',
    'sk-sk': 'sk',
    hu: 'hu',
    'hu-hu': 'hu',
    bg: 'bg',
    'bg-bg': 'bg',
    el: 'el',
    'el-gr': 'el',
    'el-cy': 'el',
    sv: 'sv',
    'sv-se': 'sv',
    'sv-fi': 'sv',
    nb: 'nb',
    'nb-no': 'nb',
    'no-no': 'nb',
    no: 'nb',
    da: 'da',
    'da-dk': 'da',
    fi: 'fi',
    'fi-fi': 'fi',
    lt: 'lt',
    'lt-lt': 'lt',
    et: 'et',
    'et-ee': 'et',
    hr: 'hr',
    'hr-hr': 'hr',
    sr: 'sr',
    'sr-rs': 'sr',
    'sr-latn': 'sr',
    'sr-latn-rs': 'sr',
    sl: 'sl',
    'sl-si': 'sl',
    tr: 'tr',
    'tr-tr': 'tr',
    'zh-cn': 'zh-CN',
    'zh-sg': 'zh-CN',
    'zh-hans': 'zh-CN',
    'zh-hans-cn': 'zh-CN',
    'zh-hans-sg': 'zh-CN',
    zh: 'zh-CN',
    'zh-tw': 'zh-TW',
    'zh-hk': 'zh-TW',
    'zh-mo': 'zh-TW',
    'zh-hant': 'zh-TW',
    'zh-hant-tw': 'zh-TW',
    'zh-hant-hk': 'zh-TW',
    ja: 'ja',
    'ja-jp': 'ja',
    ko: 'ko',
    'ko-kr': 'ko',
    hi: 'hi',
    'hi-in': 'hi',
    id: 'id',
    'id-id': 'id',
    vi: 'vi',
    'vi-vn': 'vi',
    th: 'th',
    'th-th': 'th',
    ms: 'ms',
    'ms-my': 'ms',
    'ms-bn': 'ms',
    fil: 'fil',
    'fil-ph': 'fil',
    'tl-ph': 'fil',
    tl: 'fil',
    ar: 'ar',
    'ar-sa': 'ar',
    'ar-ae': 'ar',
    'ar-eg': 'ar',
    'ar-ma': 'ar',
    'ar-dz': 'ar',
    'ar-jo': 'ar',
    'ar-kw': 'ar',
    'ar-qa': 'ar',
    'ar-bh': 'ar',
    'ar-om': 'ar',
    'ar-lb': 'ar',
    'ar-iq': 'ar',
    he: 'he',
    'he-il': 'he',
    iw: 'he',
    'iw-il': 'he',
    fa: 'fa',
    'fa-ir': 'fa',
    'fa-af': 'fa',
};
const RTL_LOCALES = new Set(['ar', 'he', 'fa']);
const NATIVE_NAMES = {
    en: 'English',
    ru: 'Русский',
    lv: 'Latviešu',
    de: 'Deutsch',
    fr: 'Français',
    es: 'Español',
    it: 'Italiano',
    pt: 'Português',
    pl: 'Polski',
    uk: 'Українська',
    ro: 'Română',
    nl: 'Nederlands',
    cs: 'Čeština',
    sk: 'Slovenčina',
    hu: 'Magyar',
    bg: 'Български',
    el: 'Ελληνικά',
    sv: 'Svenska',
    nb: 'Norsk',
    da: 'Dansk',
    fi: 'Suomi',
    lt: 'Lietuvių',
    et: 'Eesti',
    hr: 'Hrvatski',
    sr: 'Српски',
    sl: 'Slovenščina',
    tr: 'Türkçe',
    'zh-CN': '简体中文',
    'zh-TW': '繁體中文',
    ja: '日本語',
    ko: '한국어',
    hi: 'हिन्दी',
    id: 'Bahasa Indonesia',
    vi: 'Tiếng Việt',
    th: 'ไทย',
    ms: 'Bahasa Melayu',
    fil: 'Filipino',
    ar: 'العربية',
    he: 'עברית',
    fa: 'فارسی',
    'pt-BR': 'Português (Brasil)',
    'es-419': 'Español (Latinoamérica)',
};
function canonicalizeTag(tag) {
    return tag.trim().replace(/_/g, '-');
}
/**
 * Normalizes an arbitrary locale tag to a supported locale, or `null` when
 * unsupported.
 */
export function normalizeLocale(input) {
    if (!input)
        return null;
    const raw = canonicalizeTag(input);
    if (!raw)
        return null;
    const direct = LOCALE_ALIASES[raw.toLowerCase()];
    if (direct)
        return direct;
    const base = raw.split('-')[0]?.toLowerCase() ?? '';
    const baseAlias = LOCALE_ALIASES[base];
    if (baseAlias)
        return baseAlias;
    if (SUPPORTED_SET.has(raw))
        return raw;
    return null;
}
/** Whether the locale uses right-to-left text direction. */
export function isRtlLocale(locale) {
    return RTL_LOCALES.has(locale);
}
/** Native display name for a supported locale (language selector). */
export function localeNativeName(locale) {
    return NATIVE_NAMES[locale];
}
//# sourceMappingURL=locale.js.map